import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=022e250a&scoped=true"
import script from "./detail.vue?vue&type=script&setup=true&lang=js"
export * from "./detail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=022e250a&prod&lang=scss&scoped=true"
import style1 from "./detail.vue?vue&type=style&index=1&id=022e250a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022e250a",
  null
  
)

export default component.exports